import useRegistrationModal from "@/composables/useRegistrationModal";
import { ref } from "vue";

const useFileInput = (myStore, props, context, value) => {
  const { updateSelectedFile } = useRegistrationModal(myStore);
  const uploaded = ref(false);

  const parseAccepted = () =>
    props.accept
      .split(",")
      .map((type) => type.split("/")[1].toUpperCase())
      .join(", ");
  const parseMaxSize = () => `${props.maxSize} MB`;

  const url = ref(null);
  const inputRef = ref("dropFile");
  const fileName = ref("");

  const onFileChange = () => {
    const files = inputRef.value.files;
    const file = files[0];

    uploaded.value = true;
    fileName.value = file?.name;
    value.value = file;
    url.value = URL.createObjectURL(file);
    context.emit("update:modelValue", file);
    updateSelectedFile(file);
  };

  const dropImage = (e) => {
    e.preventDefault();
    inputRef.value.files = e.dataTransfer.files;
    onFileChange();
  };
  const onPickFile = () => {
    inputRef.value.click();
  };
  return {
    url,
    inputRef,
    onFileChange,
    dropImage,
    onPickFile,
    parseAccepted,
    parseMaxSize,
    uploaded,
    fileName,
  };
};

export default useFileInput;
